var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 100.0 100.0",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l100.0 0l0 100.0l-100.0 0l0 -100.0z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l100.0 0l0 100.0l-100.0 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadowFilter-p.1)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p.1",
    transform: "matrix(1.0 0.0 0.0 1.0 0.0 2.0)"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadowFilter-p.1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "blur",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFuncR", {
    type: "linear",
    slope: 0,
    intercept: 0
  }), /*#__PURE__*/React.createElement("feFuncG", {
    type: "linear",
    slope: 0,
    intercept: 0
  }), /*#__PURE__*/React.createElement("feFuncB", {
    type: "linear",
    slope: 0,
    intercept: 0
  }), /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.5,
    intercept: 0
  })))), /*#__PURE__*/React.createElement("g", {
    id: "p.1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffff00",
    d: "m6.4566927 87.66929l43.54331 -75.33858l43.543304 75.33858z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0000",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m6.4566927 87.66929l43.54331 -75.33858l43.543304 75.33858z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0000",
    d: "m48.915108 61.005535l-1.109375 -15.687496l0 -6.546875l4.5 0l0 6.546875l-1.046875 15.687496l-2.34375 0zm-0.9375 7.343754l0 -4.140625l4.171875 0l0 4.140625l-4.171875 0z",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.6d981cfda92409f29f0651712ed33559.svg";
export { ForwardRef as ReactComponent };